module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-header"
  }, [_c('div', {
    staticClass: "vux-header-left"
  }, [_vm._t("overwrite-left", [_c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm._leftOptions.showBack),
      expression: "_leftOptions.showBack"
    }],
    staticClass: "vux-header-back",
    on: {
      "click": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "preventDefault")) { return null; }
      }, _vm.onClickBack]
    }
  }, [_vm._v(_vm._s(typeof _vm._leftOptions.backText === 'undefined' ? '返回' : _vm._leftOptions.backText))])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm._leftOptions.showBack),
      expression: "_leftOptions.showBack"
    }],
    staticClass: "left-arrow",
    on: {
      "click": _vm.onClickBack
    }
  })])]), _vm._v(" "), _vm._t("left")], 2), _vm._v(" "), _c('h1', {
    staticClass: "vux-header-title",
    on: {
      "click": function($event) {
        _vm.$emit('on-click-title')
      }
    }
  }, [_vm._t("default", [_c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.title),
      expression: "title"
    }]
  }, [_vm._v(_vm._s(_vm.title))])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "vux-header-right"
  }, [(_vm.rightOptions.showMore) ? _c('a', {
    staticClass: "vux-header-more",
    on: {
      "click": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "preventDefault")) { return null; }
      }, function($event) {
        _vm.$emit('on-click-more')
      }]
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("right")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d78ac18"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/x-header/index.vue
// module id = 548
// module chunks = 1